import { BrightnessSlider } from "components/brightness-slider";
import { Disclaimer } from "components/disclaimer";

import { Sidebar } from "components/sidebar";
import { Color } from "utils/theme";

export const Layout = ({ children }) => {
  const isBeijerDisplay = window.navigator.userAgent
    .toLowerCase()
    .includes("beijer");

  return (
    <div className="flex h-full">
      <Disclaimer />
      <div className="shrink-0 h-full">
        <Sidebar />
      </div>
      <div
        className="relative flex-1 overflow-auto"
        style={{
          background: Color.Primary[900],
        }}
      >
        {children}
      </div>
      {isBeijerDisplay && (
        <div className="shrink-0 h-full w-fit p-2 pl-0">
          <BrightnessSlider />
        </div>
      )}
    </div>
  );
};
